import React, { useState, useEffect } from 'react';

const blogData = [
  {
    id: 1,
    title: "How AI is Shaping the Future of Coding and Development Jobs: A New Era at CoderMonk",
    description: "In the fast-evolving world of technology, Artificial Intelligence (AI) is not just a buzzword...",
    image: "https://cdn.pixabay.com/photo/2019/11/15/14/53/office-4628592_640.jpg",
    path:"/ai_revolution",
  },
  {
    id: 2,
    title: "Breaking Into AI & Machine Learning: A Beginner’s Guide",
    description: "Artificial Intelligence (AI) and Machine Learning (ML) are transforming industries worldwide, and the demand for skilled AI professionals is skyrocketing. If...",
    path:"/machine_learning",
    image: "https://cdn.pixabay.com/photo/2018/01/24/17/33/light-bulb-3104355_640.jpg",
  },
  {
    id: 3,
    title: "From Beginner to Pro: How to Start Your Career in Robotics",
    description: "Robotics is transforming industries, from manufacturing to healthcare, and even space exploration. If you've ever dreamed of building intelligent machines...",
    path:"/robotics",
    image: "https://cdn.pixabay.com/photo/2018/07/14/11/28/blockchain-3537389_640.jpg",
  },
  // {
  //   id: 1,
  //   title: "Why CoderMonk is Your Ideal Partner in the AI-Driven Future",
  //   description: "Located in Jalandhar, Punjab, CoderMonk is uniquely positioned to offer the most innovative coding programs in the region We pride ourselves...",

  //   image: "https://cdn.pixabay.com/photo/2019/02/07/11/21/school-3980940_640.jpg",
  // },
  // {
  //   id: 2,
  //   title: "How You Can Benefit from CoderMonk’s Services",
  //   description: "Whether you’re a beginner or an experienced developer, joining CoderMonk gives you the opportunity to immerse yourself in the world...",
   
  //   image: "https://cdn.pixabay.com/photo/2017/05/29/16/42/smartphone-2354157_640.jpg",
  // },
  // {
  //   id: 3,
  //   title: "Conclusion",
  //   description: "AI is transforming the way we code and the future of development jobs. At CoderMonk, we are dedicated to ensuring that our students are at the forefront of this change equipped with…",
  //   image: "https://cdn.pixabay.com/photo/2018/10/17/08/56/shaking-hands-3753457_640.jpg",
  // },
];

function Blog() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    // Simulating fetching data
    setBlogs(blogData);
  }, []);

  return (
    <div style={styles.container}>
   
     
<div className="container-xxl mt-5">
  <div className="container">
    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
    <div className='d-flex flex-row align-items-center justify-content-center mb-5'>
            <img 
                    className='pe-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                    <h6 className="sub_heading p">Blogs</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
     
   
    </div>
    </div>
    </div>
      <div className="container">
  <div className="row">
    {blogs.map((blog) => (
      <div key={blog.id} className="col-lg-4 col-md-6 col-sm-12">
        <div className="card h-100 shadow-sm">
          <div className="overflow-hidden">
          <img  className="card-img-top img-fluid zoom-effect"
             style={{width:"100%",height:200,objectFit:"cover"}}
            src={blog.image} alt="" />
          </div>
          <div className="card-body">
            <h6 style={styles.title}>{blog.title}</h6>
            <p style={styles.description}>{blog.description}</p>
            <a href={blog.path} className="me-2" style={{textDecoration:"none",color:"yellowgreen",fontWeight:700}}>Read More</a>
            <img src='assets/img/arrow.png' height={10} width={10}/>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

    </div>
  );
}
// backgroundColor: '#f4f4f9',
const styles = {
  container: {
    padding: '20px',
    minHeight: '100vh',
    boxSizing: 'border-box',
  },
  banner: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    marginBottom: '30px',
    gap: '20px',
    flexWrap: 'wrap',
  },
  bannerText: {
    flex: '1 1 300px',
    textAlign: 'left',
  },
  bannerHeading: {
    fontSize: '2.5em',
    color: '#333',
    margin: '0 0 10px',
  },
  bannerDescription: {
    color: '#666',
    fontSize: '1.2em',
  },
  bannerImage: {
    flex: '1 1 300px',
    textAlign: 'center',
  },
  image: {
    maxWidth: '100%',
    borderRadius: '10px',
    objectFit: 'cover',
    maxHeight:"200px"
  },
  sectionHeading: {
    textAlign: 'center',
    color: '#333',
    fontSize: '2em',
    marginBottom: '20px',
  },
  cardContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '20px',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: '10px',
    padding: '20px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    transition: 'transform 0.3s, box-shadow 0.3s',
    cursor: 'pointer',
  },
  imageContainer: {
    overflow: 'hidden',
    borderRadius: '10px',
  },
  cardImage: {
    maxWidth: '100%',
    transition: 'transform 0.3s',
    borderRadius: '10px',
  },
  title: {
    fontSize: '1rem',
    color:"#006a4f"
  },
  description: {
    color: '#001f3f',
  },
  button: {
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    padding: '10px 15px',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
};

// Add hover effects using CSS
const stylesTag = document.createElement('style');
stylesTag.innerHTML = `
  .card:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }

  .zoom-effect {
    transition: transform 0.3s;
  }

  .zoom-effect:hover {
    transform: scale(1.1);
  }
`;
document.head.appendChild(stylesTag);


export default Blog;
